<template>
    <div style="z-index: 9999 !important;">
        <submit-form width="70%" 
        :title="form.title" 
        :visible.sync="form.visible" 
        :formData="form.data" 
        :items="form.items"
        :rules="form.rules" 
        :action="form.action" 
        :innerDialog="innerDialog"
        addUrl="/api/seller/createGroup"
        updateUrl="/api/seller/updateGroup"
        :onSubmitCallback="()=>$emit('onSubmitCallback')" 
        :handleClose="()=>$emit('handleClose')"></submit-form>
    </div>
</template>

<script>
import submitForm from '../../plugin/mume-submit-form.vue';
export default {
    components:{submitForm},
    name:'group-lapyer',
    props:{
        innerDialog:{
          type:Boolean,
          default:false
        },
    },
    data(){
        return {
            form: {
                title: '创建分组',
                visible: false,
                action:'add',
                data: {
                    title: ""
                },
                items: [{
                    key: "title",
                    name: "title",
                    label: "分组名称",
                    type: "input",
                    prop: "title"
                }],
                rules: {
                    title: [{ required: true, message: '请输入分组名称', trigger: 'blur' }]
                }
            }
        }
    },
    methods:{
        open(data){
            this.form.data ={
                    title: ""
                }
            this.form.visible = true;
        },
        close(){
            this.form.visible = false;
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/customer/lapyer/add-group.vue